<template>
  <div class="business-report-viewer">
    <!-- 在手订单全年预测 -->
    <template v-if="reportType === 'order-forecast-revenue' || reportType === 'order-forecast-profit'">
      <OrderForecastReport :is-profit="reportType === 'order-forecast-profit'" />
    </template>
    <!-- 五大行业经营情况 -->
    <template v-else-if="reportType === 'industry-operation'">
      <IndustryOperationReport />
    </template>
    <!-- 业务链群经营情况 -->
    <template v-else-if="reportType === 'chain-operation'">
      <ChainOperationReport />
    </template>
    <!-- 客户结构经营情况 -->
    <template v-else-if="reportType === 'customer-structure'">
      <CustomerStructureReport />
    </template>
    <!-- 卡奥斯海外链群收入 -->
    <template v-else-if="reportType === 'overseas-chain-revenue'">
      <OverseasChainRevenueReport />
    </template>
  </div>
</template>

<script>
import OrderForecastReport from './reports/OrderForecastReport.vue'
import IndustryOperationReport from './reports/IndustryOperationReport.vue'
import ChainOperationReport from './reports/ChainOperationReport.vue'
import CustomerStructureReport from './reports/CustomerStructureReport.vue'
import OverseasChainRevenueReport from './reports/OverseasChainRevenueReport.vue'

export default {
  name: 'BusinessReportViewer',
  components: {
    OrderForecastReport,
    IndustryOperationReport,
    ChainOperationReport,
    CustomerStructureReport,
    OverseasChainRevenueReport
  },
  props: {
    reportKey: {
      type: String,
      required: true
    }
  },
  computed: {
    reportType() {
      return this.reportKey
    }
  }
}
</script>

<style scoped>
.business-report-viewer {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
}
.business-report-viewer::-webkit-scrollbar {
  width: 4px;
}
.business-report-viewer::-webkit-scrollbar-track {
  background: transparent;
}
.business-report-viewer::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
</style>
